module.exports = __webpack_public_path__ + "static/media/icon.ff4087c2.png";